export const NO_DEVICE_OWNER_FLAG = 'none';

export const NO_DEVICE_OWNER_OPTION = {
  value: NO_DEVICE_OWNER_FLAG,
  label: 'No device owner',
  hint: 'Created with an enrollment code',
};

export const ANY_DEVICE_OWNER_FLAG = 'any';

export const ANY_DEVICE_OWNER_OPTION = {
  value: ANY_DEVICE_OWNER_FLAG,
  label: 'Any device owner',
  hint: 'Created with an OIDC enroll',
};
